<template>
    <div>
        <div class="modal is-active" v-show="showEmailToClientModal">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Email to client</p>
                    <button class="delete" aria-label="close" @click="closeModal"></button>
                </header>
                <section class="modal-card-body">
                    <loading :active.sync="isLoadingModal" color="#3BAFDA" :can-cancel="false" :is-full-page="isFullPage"></loading>
                    <div class="columns" v-show="isLoadingModal == false">
                        <div class="column is-6">
                            <div class="field">
                                <label class="label is-small">Your email</label>
                                <div class="control">
                                    <input type="text" class="input is-small" v-model="salesQuoteUserAndClient.userEmail" disabled />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label class="label is-small">Client</label>
                                <div class="control">
                                    <input type="text" class="input is-small" v-model="salesQuoteUserAndClient.client" disabled />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label class="label is-small">Contact person</label>
                                <div class="control">
                                    <input type="text" class="input is-small" v-model="salesQuoteUserAndClient.contactPerson" disabled />
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <label class="label is-small">Contact title</label>
                                <div class="control">
                                    <input type="text" class="input is-small" v-model="salesQuoteUserAndClient.contactTitle" disabled />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-6">
                            <div class="field">
                                <label class="label is-small">Client email</label>
                                <div class="control">
                                    <input type="text" class="input is-small" v-model="salesQuoteUserAndClient.clientEmail" v-validate="'required|email'" name="Client email" />
                                    <span style="font-size:12px" class="has-text-danger">{{ errors.first('Client email') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot" style="justify-content:flex-end">
                    <button :class="buttonIsSendToEmail" @click="sendToClient">Send</button>
                    <button class="button is-small" @click="closeModal">Cancel</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapActions } from 'vuex'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'
import Loading from 'vue-loading-overlay'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  components: {
    Loading
  },
  data: () => ({
    salesQuoteUserAndClient: {},
    //buttons
    buttonIsSendToEmail: appButton.isLoadingInfoInverted(false),
    // loadings
    isLoadingModal: false,
    isFullPage: false
  }),
  computed: {
    ...mapState('salesquote', {
      showEmailToClientModal: state => state.showEmailToClientModal,
      salesQuoteForEmailToClient: state => state.salesQuoteForEmailToClient
    })
  },
  methods: {
    ...mapActions('salesquote', [
      'openEmailToClientModal',
      'getPaginatedSalesQuotes'
    ]),
    sendToClient() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.buttonIsSendToEmail = appButton.isLoadingInfo(true)
          axios
            .post(
              `downloadables/salesquote?id=${
                this.salesQuoteUserAndClient.salesQuoteId
              }&isSendToEmail=true&clientEmail=${
                this.salesQuoteUserAndClient.clientEmail
              }`
            )
            .then(response => {
              appToast.success(response.data)
            })
            .catch(error => appToast.danger(error))
            .then(() => {
              this.buttonIsSendToEmail = appButton.isLoadingInfo(false)
              this.buttonIsSendToEmail = appButton.isLoadingInfoInverted(false)
            })
        }
      })
    },
    closeModal() {
      this.default()
    },
    default() {
      this.openEmailToClientModal({
        showEmailToClientModal: false
      })
      this.getPaginatedSalesQuotes({
        page: 1,
        pageSize: 10,
        query: ''
      })

      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    getSalesQuoteUserAndClientInfo(salesQuoteId) {
      if (salesQuoteId) {
        this.isLoadingModal = true
        axios
          .get(
            `api/salesquotes/sales-quote-user-and-client-info/${salesQuoteId}`
          )
          .then(response => {
            this.salesQuoteUserAndClient = response.data
          })
          .catch(error => console.log(error))
          .then(() => {
            this.isLoadingModal = false
          })
      }
    }
  },
  watch: {
    showEmailToClientModal() {
      if (this.showEmailToClientModal) {
        if (this.salesQuoteForEmailToClient) {
          this.getSalesQuoteUserAndClientInfo(
            this.salesQuoteForEmailToClient.salesQuoteId
          )
        }
      }
    }
  }
}
</script>
